export default "__VITE_ASSET__CZHJwyiy__"